module.exports = "<p>\n <button (click)=\"startVerification()\"> start Verification</button>\n</p>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/veriff/veriff.component.html
// module id = ./src/app/veriff/veriff.component.html
// module chunks = main